// extracted by mini-css-extract-plugin
module.exports = {"city":"search-item_city__OqolF"};